<app-shipment-system-simplenav></app-shipment-system-simplenav>
<div class="container-fluid">

<div class="row">
    <div class="col form-group">
        <label class="control-label" i18n>Branch</label>
        <select class="custom-select custom-select-sm me-1"
                [(ngModel)]="options.branch"
        >
            <option i18n [ngValue]="null">Pick branch</option>
            <ng-template ngFor let-shipmentRoute [ngForOf]="branches">
                <option [ngValue]="shipmentRoute.key">
                    {{ shipmentRoute.name }}
                </option>
            </ng-template>
        </select>
    </div>
    <div class="col form-group">
        <label for="shipment-system-start-date" i18n>Date:</label>
        <app-date-time-picker [(date)]="options.startDate"
                              [options]="{calendarWeeks:true, format: 'DD-MM-YYYY'}"
                              [inputSmall]="true"
                              (dateChange)="dateChanged($event)"
                              id="shipment-system-start-date"
                              type="text"
                              name="calendarWeeks"></app-date-time-picker>
    </div>

    <div class="col form-group">
        <label>&nbsp;</label>
        <div>
            <button (click)="reloadShipments()" class="btn  btn-sm  btn-success"
                    [disabled]="loadingShipments">
                <i class="fas fa-search"></i>&nbsp;<ng-container i18n>Fetch</ng-container>
            </button>
        </div>
    </div>
</div>


    <div *ngIf="shipments && shipmentRoutes">
    <app-shipping-system-table [shipmentRoute]="null"
                               [branch]="options.branch"
                               [shipmentRoutes]="shipmentRoutes"
                               [showHeader]="true"
                               [header]="'Plukkekø'"
                               [shipments]="shipments"
                               [expandOrderLines]="false"
                               [enableTempSorting]="true"
                               [showDate]="true"
                               (shipmentsChanged)="reloadShipments()"></app-shipping-system-table>


    <!--
        <app-shipping-system-sorter
            [sortfield]="'picking_sorting'"
            [shipments]="shipments"
            [options]="options"
            [shipmentRoutes]="shipmentRoutes"
            [branch]="options.branch"
            [oneDay]="true"
            (shipmentsChanged)="reloadShipments()"
            (routeChanged)="routeChanged($event)"></app-shipping-system-sorter>
    -->
    </div>
</div>
